import { generatePath, Link, useParams } from "react-router-dom";
import { OldGrid } from "src/components/atoms/OldGrid/OldGrid";
import { OldRow } from "src/components/atoms/OldGrid/OldRow";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import Styles from "./Users.module.scss";
import { useGetTeamUsersByIDQuery } from "src/state/modules/api";
import PageLoader1 from "src/components/atoms/PageLoader/PageLoader";
import { ROUTES } from "src/utils/constants/routes";

export type PitchSmartTableData = {
  first_name: string;
  last_name: string;
  email: string;
  status: string;
  associations: string;
};

function Users() {
  const { id } = useParams<{ id: string }>();
  const teamID = id ?? "";
  const { data, isLoading } = useGetTeamUsersByIDQuery(teamID);

  if (isLoading) return <PageLoader1 />;

  if (!data) {
    return (
      <h3>
        No User Data Found. Try to import by <Link to={generatePath(ROUTES.import)}>searching</Link>.{" "}
      </h3>
    );
  }

  return (
    <OldGrid centered={false} className={Styles.statsPageContainer}>
      <OldRow>
        <div className="DataTableOverride__stickyItem">
          <div className="ag-theme-quartz">
            <h1>Users</h1>
            <AgGridReact
              domLayout="autoHeight"
              columnHoverHighlight={true}
              rowData={data}
              columnDefs={[
                {
                  field: "first_name",
                  headerName: "First",
                  cellStyle: { textAlign: "left" },
                },
                {
                  field: "last_name",
                  headerName: "Last",
                  cellStyle: { textAlign: "left" },
                  sort: "asc",
                },
                {
                  field: "email",
                  headerName: "Email",
                  cellStyle: { textAlign: "left" },
                  width: 300,
                },
                {
                  field: "status",
                  headerName: "Status",
                  cellStyle: { textAlign: "center" },
                },
                {
                  field: "association",
                  headerName: "Association",
                  cellStyle: { textAlign: "center" },
                },
              ]}
            />
          </div>
        </div>
      </OldRow>
    </OldGrid>
  );
}

export default Users;
